import React from 'react'
import Navbar from './navBar'
import '../../styles/global.css'

export default function Layout({children}) {
  return (
    <div className='layout'>
        <Navbar />
        <div className="contents">
            {children}
        </div>
    </div>
  )
}
